<template>
  <section v-maximizable>
    <div class="table-tab">
    <div class="table-tab__actions-block" v-if="canEdit">
      <table class="table-tab__block table" style="width: 140px">
        <thead class="table-tab__thead">
        <tr class="table-tab__row-auto-height">
          <th>{{$t('labels.actions')}}</th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template  v-for="(item, rowId) in info">
          <tr class="table-tab__row-auto-height table-tab__tr table-tab__tr-border">
            <template v-if="item.rule && item.editable">
              <th class="table-tab__actions table-tab__actions--redaction u-align-items-start">
                <div class="table-tab__actions">
                  <button type="button" @click="confirmEditable(rowId)" :title="$t('buttons.save')">
                    <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                  </button>
                  <button type="button" @click="cancelEditable(rowId)" :title="$t('buttons.cancel')">
                    <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
            <template v-else>
              <th class="table-tab__actions">
                <div class="table-tab__actions" v-if="item.isAdditional">
                  <button type="button" :title="$t('buttons.modify')" @click="editItem(rowId)" :disabled="hasEditable">
                    <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                  </button>
                </div>
              </th>
            </template>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <div class="table-tab__container"
         style="overflow: hidden; overflow-x: auto; outline: none;"
         :style="`max-width: calc(100% - ${canEdit ? '140px': 0})`">
      <table class="table-tab__block table " style="width: 2400px">
        <thead class="table-tab__thead">
        <tr class="table-tab__row-auto-height">
          <th class="table-tab__width-90 table-tab__th--row">№</th>

          <th>Возможность применения доп. расхода</th>
          <th style="width: 140px">{{$t('form.catalogs.catalog-type.present-price.table.resident')}}</th>
          <th v-html="$t('form.catalogs.catalog-type.present-price.table.bid-currency')"></th>
          <th>{{$t('form.catalogs.catalog-type.present-price.table.contract-currency')}}</th>
          <th v-html="$t('form.catalogs.catalog-type.present-price.table.payment-currency')"></th>
<!--          <th class="table-tab__border-right " style="width: 150px">{{$t('form.catalogs.catalog-type.present-price.table.fix-currency')}}</th>-->

          <th class="table-tab__width-180">{{$t('form.catalogs.catalog-type.present-price.table.price-forming-description')}}</th>
          <th>{{$t('form.catalogs.catalog-type.present-price.table.price-forming')}}</th>
          <th>Подсказка участнику по варианту формирования цены и валюты</th>
          <th style="width: 160px">{{$t('form.catalogs.catalog-type.present-price.table.currency-clause')}}</th>
          <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.fix-date')}}</th>
          <th style="width: 300px">{{$t('form.catalogs.catalog-type.present-price.table.payment-date')}}</th>
          <th >Возможность аванса</th>

          <th class="table-tab__width-140"></th>
        </tr>
        </thead>
        <tbody class="table-tab__tbody">
        <template v-for="(item, i) of info">
          <tr class="table-tab__tr-border table-tab__row-auto-height"
              :class="{'table-tab__background-red': item.rule}">
            <template>
              <th class="table-tab__th table-tab__th--row">
                {{i + 1}}
              </th>
              <td>
                <div class="a-checkbox" :class="{'a-checkbox--disable': !canEdit}">
                  <label class="a-checkbox__label">
                    <input class="a-checkbox__input"
                           type="checkbox"
                           :disabled="!canEdit"
                           :checked="!!item.rule"
                           @click.prevent="onAddItemClick(i, $event.target.checked)">
                    <span class="a-checkbox__icon"></span>
                  </label>
                </div>
              </td>
              <td>
                <p class="a-input--disabled">{{$t(item.status.label)}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{$t(item.bidCurrency.label)}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{$t(item.contractCurrency.label)}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{item.paymentCurrency}}</p>
              </td>
<!--              <td class="table-tab__border-right ">-->
<!--                <p class="a-input&#45;&#45;disabled">{{item.fixBynComment}}</p>-->
<!--              </td>-->

              <td>
                <p class="a-input--disabled">{{item.bidRuleComment}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{$t(item.type.label)}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{item.bidRuleUserComment}}</p>
              </td>
              <td>
                <p class="a-input--disabled">{{$t(item.currencyClause.label)}}</p>
              </td>
              <td>
                <dropdown-new class="select-w-100-percent"
                              :options="enums.FixDateChoice.options.mandatory"
                              v-model="item.fixDate"
                              v-if="item.editable">
                </dropdown-new>
                <p class="a-input--disabled" v-else>{{$t(item.fixDate.label)}}</p>
              </td>
              <td>
                <dropdown-new class="select-w-100-percent"
                              :options="enums.PaymentDateChoice.options.mandatory"
                              v-model="item.paymentDate"
                              v-if="item.editable">
                </dropdown-new>
                <p class="a-input--disabled" v-else>{{$t(item.paymentDate.label)}}</p>
              </td>
              <td>
                <div class="a-checkbox a-checkbox--disable">
                  <label class="a-checkbox__label">
                    <input class="a-checkbox__input"
                           type="checkbox"
                           disabled
                           v-model="item.allowAdvance">
                    <span class="a-checkbox__icon"></span>
                  </label>
                </div>
              </td>
              <td>
              </td>
            </template>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <loading v-if="loading"></loading>
    <confirmation-dialog ref="confirmation" close-on-action></confirmation-dialog>
  </div>
  </section>
</template>

<script>
  import $ from 'jquery'
  import ConfirmationDialog from "../../../common/dialogs/ConfirmationDialog";

  export default {
    components: {ConfirmationDialog},
    props: {
      rules: {
        type: Array,
        required: true,
        default: () => []
      },

      additionalExpense: {
        type: Number,
        required: true
      },

      canEdit: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      hasEditable: null,
      backup: undefined,
      summary: []
    }),

    computed: {
      items() {
        return this.$store.getters.bidRules.items;
      },

      info() {
        return this.summary;
      },

      // additionalRules() {
      //   return this.rules.reduce((acc, v) => {
      //     acc[v.rule] = v;
      //     return acc;
      //   }, {});
      // }
    },

    watch: {
      hasEditable(value) {
        this.$emit('edit', !!value);
      },

      items: {
        immediate: true,
        deep: true,
        handler() {
          this.summary = this.items.map(r => {
            const rule = _.find(this.rules, { rule: r.id }) || {};
            return {
              ...r,
              ...rule,
              isAdditional: rule.rule
            };
          });
        }
      },

      rules: {
        immediate: true,
        deep: true,
        handler() {
          this.summary = this.items.map(r => {
            const rule = _.find(this.rules, { rule: r.id }) || {};
            return {
              ...r,
              ...rule,
              isAdditional: rule.rule
            };
          });
        }
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchBidRulesFromCatalog');
        }
        catch(e) {
          console.error(e);
        }
      });
    },

    mounted() {
      this._updateTableRowsHeight();
    },

    updated() {
      this._updateTableRowsHeight();
    },

    methods: {
      onAddItemClick(rowId, isChecked) {
        this.$refs.confirmation.open({
          title: 'Возможность применения доп. расхода',
          text: isChecked ?
                  'Вы уверены что хотите добавить возможность применения доп. расхода?' :
                  'Вы уверены что хотите удалить возможность применения доп. расхода?',
          onConfirm: () => {
            if (isChecked) {
              const rule = _.cloneDeep(this.items[rowId]);
              rule.rule = rule.id;
              rule.id = undefined;

              this.runAction(async () => {
                try {
                  await this.$store.dispatch('addAdditionalBidRuleToCatalog',
                    { additionalExpense: this.additionalExpense, data: rule });
                }
                catch(e) {
                  console.error('unable to add additional bid rule to catalog', e);
                  this.globalErrorHandler(e)
                }
              });
            }
            else {
              this.deleteItem(rowId);
            }
          }
        });
      },

      deleteItem(rowId) {
        this.runAction(async() => {
          try {
            await this.$store.dispatch('deleteAdditionalBidRuleToCatalog', this.info[rowId]);
          }
          catch(e) {
            this.showError({title: 'Ошибка', error: 'Что-то пошло не так'});
          }
        });
      },

      editItem(rowId) {
        if (this.hasEditable) return;

        this.hasEditable = { row: rowId };

        this.backup = _.cloneDeep(this.info[rowId]);
        this.$set(this.info[rowId], 'editable', true);
      },

      async confirmEditable(rowId) {
        if (!this.hasEditable) return;

        const item = this.info[rowId];

        this.runAction(async () => {
          try {
            await this.$store.dispatch('modifyAdditionalBidRuleToCatalog',
              { additionalExpense: this.additionalExpense, data: item } );
            this.hasEditable = null;
          }
          catch(e) {
            console.error('unable to modify file extension in catalog', e);
            this.globalErrorHandler(e)
          }
        });
      },

      cancelEditable(rowId) {
        if (!this.hasEditable) return;

        this.$set(this.summary, this.hasEditable.row, this.backup);

        this.hasEditable = null;
        this.backup = undefined;
      },

      _updateTableRowsHeight() {
        const dataRows = $(this.$el).find('.table-tab__container .table-tab__row-auto-height');
        const controlRows = $(this.$el).find('.table-tab__actions-block .table-tab__row-auto-height');

        if (dataRows.length !== controlRows.length) {
          console.error('amount of data and control rows should be the same');
          return;
        }

        for (let i = 0; i < dataRows.length; ++i) {
          const $d = $(dataRows[i]);
          const $c = $(controlRows[i]);

          const height = Math.max($d.height(), $c.height());

          $d.height(height);
          $c.height(height);
        }
      },

      contractCurrencies(item) {
        const currencies = [{id: this.enums.BynOrAnotherCurrency.BYN, name: 'currency.byn'}];

        if (item.bidCurrency.valueOf() === this.enums.BynOrAnotherCurrency.NOT_BYN) {
          currencies.push({id: this.enums.BynOrAnotherCurrency.NOT_BYN, name: 'form.catalogs.catalog-type.present-price.currency.the-same'})
        }
        else {
          currencies.push({id: this.enums.BynOrAnotherCurrency.NOT_BYN, name: 'currency.not-byn'})
        }

        return currencies;
      },
    }
  }
</script>

<style scoped>
  .has-additional-rule {
    border: solid 1px red;
  }
</style>
